import React, { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';
import { state } from '../../store/global';
import API from '../../lib/api';

import LoginRightWrapper from '../../components/common/LoginRightWrapper';
import LoginLeftSide from '../../components/common/LoginLeftSide';
import LoginFooter from '../../components/common/LoginFooter';
import NormalButton from '../../components/common/NormalButton';
import PhoneNumberInputbox from '../../components/common/PhoneNumberInputbox';
import { useForceLightTheme } from '../../lib/theme';

export default function LoginUpdatePhone() {
  useForceLightTheme();

  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const [phonenumber, setPhonenumber] = useState({
    nationality: {
      country: '',
      areaCode: '',
      flag: '',
    },
    number: '',
  });
  const [error, setError] = useState(false);

  useEffect(() => {
    setPhonenumber({
      nationality: {
        country: snap.user.phonenumber.nationality.country || 'colombia',
        areaCode: snap.user.phonenumber.nationality.area_code || '+57',
        flag: '',
      },
      number: snap.user.phonenumber.number || '',
    });
  }, [snap.user.phonenumber]);

  const onChangePhonenumber = (type, value) => {
    let newPhone = { ...phonenumber };
    newPhone[type] = value;
    setPhonenumber(newPhone);
  };

  const onPhoneVerify = async () => {
    await API.post('auth/sendCodeToPhone', {
      phonenumber: phonenumber.nationality.areaCode + phonenumber.number,
    })
      .then(() => {
        state.onChangeUserInfo('phonenumber', {
          nationality: {
            area_code: phonenumber.nationality.areaCode,
            country: phonenumber.nationality.country,
          },
          number: phonenumber.number,
        });
        navigate('/login/phoneVerify');
      })
      .catch((err) => {
        console.log('err: ', err);
        setError(true);
      });
  };
  const onGoToPage = (path) => {
    navigate(path);
  };

  return (
    <div className="flex min-h-screen">
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        {/* Modal content with exact size */}
        <div className="relative z-10 bg-white rounded-2xl shadow-xl w-[1044px] h-[700px] overflow-hidden">
          <div className="flex flex-col md:flex-row w-full h-full">
            {/* Left Side - Image */}
            <LoginLeftSide />

            {/* Right Side - Form */}
            <div className="w-full h-full flex flex-col justify-between md:w-1/2 p-10 bg-[#F9F9F9]">
              <LoginRightWrapper
                onGoToPage={(path) => onGoToPage(path)}
                backPath="/login/phoneset"
              />

              <div className="h-80">
                <div className="space-y-6 font-[poppins] font-semibold pl-0 pr-0 md:pl-14 md:pr-14">
                  <div className="space-y-4">
                    <h2 className="text-xl text-[#333333] font-bold leading-[20px] tracking-[0%]">
                      Editar número de teléfono
                    </h2>
                    <div className="space-y-5 text-sm text-[#717680] font-normal leading-[20px] tracking-[0%]">
                      <h3>
                        ngresá tu número de teléfono para recibir el código de
                        verificación por SMS.
                      </h3>
                    </div>
                  </div>

                  <div className="space-y-1">
                    <PhoneNumberInputbox
                      phonenumber={phonenumber}
                      onChange={(type, value) =>
                        onChangePhonenumber(type, value)
                      }
                    />
                    <p className="font-[poppins] text-xs text-[#F04438] font-normal">
                      {error ? 'Número de teléfono inválido' : ''}
                    </p>
                  </div>

                  <NormalButton
                    customClass="w-full bg-[#092F7B] text-white"
                    text="Confirmar"
                    onClick={onPhoneVerify}
                  />
                </div>
              </div>

              {/* Login footer */}
              <LoginFooter onClick={() => navigate('/contact')} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
